document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.site-header');
  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-close]');
  const cartCountEls = Array.from(document.querySelectorAll('[data-cart-count]'));
  const cartItems = drawer ? drawer.querySelector('[data-cart-items]') : null;
  const cartSubtotal = drawer ? drawer.querySelector('[data-cart-subtotal]') : null;
  const cartProgress = drawer ? drawer.querySelector('[data-cart-progress]') : null;
  const cartShippingNote = drawer ? drawer.querySelector('[data-cart-shipping-note]') : null;
  const cartOpenTriggers = Array.from(document.querySelectorAll('[data-cart-open]'));
  const cartCloseTriggers = Array.from(document.querySelectorAll('[data-cart-close]'));

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuBackdrop = document.querySelector('.mobile-menu-backdrop');
  const mobileMenuOpenTriggers = Array.from(document.querySelectorAll('[data-mobile-menu-open]'));
  const mobileMenuCloseTriggers = Array.from(document.querySelectorAll('[data-mobile-menu-close]'));

  const setMobileMenuOpen = (open) => {
    if (!mobileMenu || !mobileMenuBackdrop) return;
    mobileMenu.hidden = !open;
    mobileMenuBackdrop.hidden = !open;
    document.documentElement.classList.toggle('mobile-menu-open', open);
    document.body.classList.toggle('mobile-menu-open', open);
  };

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format((cents || 0) / 100);
    } catch (error) {
      return `$${((cents || 0) / 100).toFixed(2)}`;
    }
  };

  const setDrawerOpen = (open) => {
    if (!drawer || !backdrop) return;
    drawer.hidden = !open;
    backdrop.hidden = !open;
    document.documentElement.classList.toggle('cart-drawer-open', open);
    document.body.classList.toggle('cart-drawer-open', open);
  };

  const renderCart = (cart) => {
    if (!drawer || !cartItems) return;
    const threshold = 4000;
    const progress = Math.min(100, Math.round((cart.items_subtotal_price / threshold) * 100));
    const remaining = Math.max(0, threshold - cart.items_subtotal_price);
    cartCountEls.forEach((el) => { el.textContent = cart.item_count; });
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.items_subtotal_price);
    if (cartProgress) cartProgress.style.width = `${progress}%`;
    if (cartShippingNote) {
      cartShippingNote.textContent = cart.items_subtotal_price >= threshold
        ? 'You qualify for free shipping ♡'
        : `${formatMoney(remaining)} away from free shipping.`;
    }

    if (!cart.items || cart.items.length === 0) {
      cartItems.innerHTML = `
        <div class="cart-drawer__empty">
          <img src="${window.themeAssets?.mascot || ''}" alt="">
          <p>Your bag is empty. Let's fix that.</p>
          <a class="button button--primary" href="${window.themeRoutes?.allProducts || '/collections/all'}">Shop beans ✦</a>
        </div>`;
      return;
    }

    cartItems.innerHTML = cart.items.map((item, index) => {
      const image = item.image ? item.image : window.themeAssets?.bag || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : 'Whole bean';
      return `
        <div class="cart-drawer__item">
          <a class="cart-drawer__thumb" href="${item.url}">
            <img src="${image}" alt="">
          </a>
          <div class="cart-drawer__meta">
            <h3>${item.product_title}</h3>
            <p>${variant} · Qty ${item.quantity}</p>
            <button type="button" class="cart-drawer__remove" data-cart-remove-line="${index + 1}">Remove</button>
          </div>
          <div class="cart-drawer__price">${formatMoney(item.final_line_price)}</div>
        </div>`;
    }).join('');

    cartItems.querySelectorAll('[data-cart-remove-line]').forEach((button) => {
      button.addEventListener('click', async () => {
        const line = button.getAttribute('data-cart-remove-line');
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        });
        refreshCart();
      });
    });
  };

  const refreshCart = async () => {
    if (!drawer) return;
    const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await response.json();
    renderCart(cart);
  };

  cartOpenTriggers.forEach((trigger) => {
    trigger.addEventListener('click', async (event) => {
      event.preventDefault();
      await refreshCart();
      setDrawerOpen(true);
    });
  });
  cartCloseTriggers.forEach((trigger) => trigger.addEventListener('click', () => setDrawerOpen(false)));

  mobileMenuOpenTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      setMobileMenuOpen(true);
    });
  });
  mobileMenuCloseTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      setMobileMenuOpen(false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setDrawerOpen(false);
      setMobileMenuOpen(false);
      setMobileMenuOpen(false);
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    if (link.matches('[data-cart-open], [data-cart-close], [data-mobile-menu-open], [data-mobile-menu-close]')) return;
    if (link.target === '_blank') return;
    if (link.href && link.origin === window.location.origin) {
      setDrawerOpen(false);
      setMobileMenuOpen(false);
    }
  }, true);

  window.addEventListener('pagehide', () => { setDrawerOpen(false); setMobileMenuOpen(false); });
  window.addEventListener('beforeunload', () => { setDrawerOpen(false); setMobileMenuOpen(false); });

  if (header) {
    const onScroll = () => header.dataset.scrolled = window.scrollY > 8 ? 'true' : 'false';
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantsScript = form.querySelector('[data-product-variants]');
    const variantIdInput = form.querySelector('[data-variant-id]');
    const submitButton = form.querySelector('[data-submit-button]');
    if (!variantsScript || !variantIdInput) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (error) {
      return;
    }

    const optionSelects = Array.from(form.querySelectorAll('select[name^="options["]'));
    const getSelectedValues = () => optionSelects.map((select) => select.value);

    const syncVariant = () => {
      const selectedValues = getSelectedValues();
      const matched = variants.find((variant) => selectedValues.every((value, index) => variant.options[index] === value));
      if (!matched) return;
      variantIdInput.value = matched.id;
      if (submitButton) {
        submitButton.disabled = !matched.available;
        submitButton.textContent = matched.available ? 'Add to bag' : 'Sold out';
      }
    };

    optionSelects.forEach((select) => select.addEventListener('change', syncVariant));
    syncVariant();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-product-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
    if (!mainImage || thumbs.length === 0) return;
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-full-src');
        if (fullSrc) mainImage.src = fullSrc;
        thumbs.forEach((btn) => btn.classList.remove('on'));
        thumb.classList.add('on');
      });
    });
  });

  document.querySelectorAll('form[data-ajax-cart-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const previousLabel = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!response.ok) throw new Error('Unable to add item');
        await refreshCart();
        setDrawerOpen(true);
      } catch (error) {
        alert('Unable to add this item to your bag right now.');
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = previousLabel || 'Add to bag';
        }
      }
    });
  });

  setDrawerOpen(false);
  setMobileMenuOpen(false);
  refreshCart().catch(() => {});
});
